"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorWithOpacity = exports.getOpacityAsHex = void 0;
var getOpacityAsHex = function (alphaPercentage) {
    var intValue = Math.round((alphaPercentage / 100) * 255);
    var hexValue = intValue.toString(16);
    return hexValue.padStart(2, '0').toUpperCase();
};
exports.getOpacityAsHex = getOpacityAsHex;
var getColorWithOpacity = function (color, alphaPercentage) {
    var alphaHex = (0, exports.getOpacityAsHex)(alphaPercentage);
    return "".concat(color).concat(alphaHex);
};
exports.getColorWithOpacity = getColorWithOpacity;
//# sourceMappingURL=Color.js.map